import { render, staticRenderFns } from "./TrainingProgramsDialog.vue?vue&type=template&id=6cd475cb&"
import script from "./TrainingProgramsDialog.vue?vue&type=script&lang=js&"
export * from "./TrainingProgramsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports